






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { NewsModule } from '@/store/modules/news/news.store';
import { ValidationObserver } from 'vee-validate/dist/types/components/Observer';
import { UserModule } from '@/store/modules/user/user.store';
import { NewsViewObject } from '@/types/apiServerContract';

@Component
export default class NewsArticleSubmitComment extends Vue {
	@Prop({ required: true }) news!: NewsViewObject;

	loading: boolean = false;
	comment: string = '';

	timeUntilNextNewsComment() {
	    const now = new Date();
	    return UserModule.lastNewsComment ? Math.round((UserModule.lastNewsComment.getTime() - now.getTime()) / 1000) : 0;
	}

	async submit() {
	    if (this.timeUntilNextNewsComment() > 0) {
	        this.$bvToast.toast(`You must wait ${this.timeUntilNextNewsComment()} seconds, before submitting a new comment.`, {
	            variant: 'danger',
	            title: 'Failed',
	            solid: true
	        });

	        return;
	    }

	    this.loading = true;

	    try {
	        await NewsModule.AddComment({ newsId: this.news.id, comment: this.comment });

	        this.reset();
	        this.$emit('submit');
	        UserModule.SetNewsCommentTimer(30);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Comment submitted successfully', {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	reset() {
	    this.comment = '';
	    this.$refs.validator.reset();
	}

	public $refs!: {
		validator: InstanceType<typeof ValidationObserver>;
	};
}
